<mat-toolbar class="header-toolbar">
  <div class="toolbar-content">
    <div class="toolbar-left">
      <h1 class="toolbar-title">
        <span class="brand-logo"><img src="iflyfinance-logo.png" alt="iFlyFinance" /></span>
      </h1>
    </div>
    <div class="toolbar-center" *ngIf="showNavigation">
      <button mat-button (click)="onNavigateToQuotes()">
        <mat-icon>request_quote</mat-icon>
        Quotes
      </button>
      <button mat-button (click)="onNavigateToCustomers()">
        <mat-icon>groups</mat-icon>
        Customers
      </button>
      <button
        *ngIf="hasSuperAdminRole()"
        mat-button
        (click)="onNavigateToDashboards()">
        <mat-icon>analytics</mat-icon>
        Dashboards
      </button>
      <button
        *ngIf="hasAdminRole()"
        mat-button
        (click)="onNavigateToPrograms()">
        <mat-icon>settings</mat-icon>
        Programs
      </button>
      <button
        *ngIf="hasAdminRole()"
        mat-button
        (click)="onNavigateToProducers()">
        <mat-icon>people</mat-icon>
        Producers
      </button>
      <button
        *ngIf="hasAdminRole()"
        mat-button
        (click)="onNavigateToApiKey()">
        <mat-icon>vpn_key</mat-icon>
        API Key
      </button>
      <button
        *ngIf="hasSuperAdminRole()"
        mat-button
        (click)="onNavigateToInsuranceCompanies()">
        <mat-icon>business</mat-icon>
        Insurance Companies
      </button>
    </div>
    <div class="toolbar-right" *ngIf="showUserInfo || showLogout">
      <span class="company-chip" *ngIf="showUserInfo && companyName" [matTooltip]="'Your agency'">
        {{ companyName }}
      </span>
      <span class="user-info" *ngIf="showUserInfo">
        Welcome, {{ userDisplayName }}
      </span>
      <button
        *ngIf="showLogout"
        mat-icon-button
        (click)="onLogout()">
        <mat-icon>logout</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>
